import {
  AppShell,
  Box,
  Button,
  Container,
  Group,
  Image,
  Text,
} from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { HarvestProofIntro } from '../harvest-proof-intro/harvest-proof-intro';

import classes from './farmer-layout.module.css';

import { precifieldLogoIcon, saipolLogo } from '@assets';

interface FarmerLayoutProps extends PropsWithChildren {
  subtitle?: string;
  onBack?: () => void;
  backLabel?: string;
}

export const FarmerLayout: FC<FarmerLayoutProps> = ({
  children,
  subtitle,
  onBack,
  backLabel = 'Toutes les parcelles',
}) => {
  const { t } = useTranslation();

  return (
    <AppShell
      className={classes.shell}
      footer={{ height: 28 }}
      header={{ height: { base: 48, sm: 56 } }}
      padding={0}
    >
      <AppShell.Header className={classes.header}>
        <Group className={classes.headerInner} h="100%" wrap="nowrap">
          <Box className={classes.logoContainer}>
            <Image
              alt="Saipol"
              className={classes.logo}
              fit="contain"
              src={saipolLogo}
            />
          </Box>
          <Box className={classes.headerActions}>
            {onBack ? (
              <Button
                className={classes.backButton}
                color="white"
                leftSection={<IconArrowLeft size={18} stroke={2} />}
                onClick={onBack}
                variant="subtle"
              >
                {backLabel}
              </Button>
            ) : null}
          </Box>
        </Group>
      </AppShell.Header>

      <AppShell.Main className={classes.main}>
        <Container className={classes.content} px={0} py={0} size="sm">
          <HarvestProofIntro accountName={subtitle} />
          {children}
        </Container>
      </AppShell.Main>

      <AppShell.Footer bg="gray.1" px="sm">
        <Group h="100%">
          <Group gap="xs">
            <Image
              alt="Precifield logotype"
              flex={0}
              src={precifieldLogoIcon}
              w={24}
            />
            <Text c="dimmed" size="xs">
              {t('common.footer_mark')}
            </Text>
          </Group>
        </Group>
      </AppShell.Footer>
    </AppShell>
  );
};
